// A message that needs to stay reactive to the current language. The bug
// this exists to prevent: calling t("key") once and storing the resolved
// *string* in component state means that string is frozen in whatever
// language was active at the time — flipping the language toggle afterward
// does nothing, because nothing ever calls t() again for it. Storing the
// key (and vars) instead, and resolving it at render time via
// resolveMessage(t, msg), keeps it live across language changes like every
// other translated string on the page.
//
// The `raw` variant exists for genuinely untranslatable text — e.g. an error
// message that came directly from Supabase/a third-party API in English.
// There's no Spanish version of that text anywhere in our system, so it
// honestly can't follow the toggle; this type just makes that an explicit,
// intentional case rather than an accidental one.
export type Message = { key: string; vars?: Record<string, string | number> } | { raw: string };

export function resolveMessage(
  t: (key: string, vars?: Record<string, string | number>) => string,
  msg: Message,
): string {
  return "raw" in msg ? msg.raw : t(msg.key, msg.vars);
}
